import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box, Flex, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { JiraAppSelectorIconWithGithub } from './jira-app-selector-with-github';
import { messages } from './messages';

const styles = cssMap({
	moreButtonStyles: {
		alignItems: 'center',
		backgroundColor: token('color.background.neutral'),
		borderRadius: token('radius.small'),
		display: 'flex',
		marginLeft: token('space.050'),
		paddingLeft: token('space.050'),
		paddingRight: token('space.050'),
	},
});

type Props = {
	appCount?: number;
};

export const AllAppsIconWithGithub = ({ appCount }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const label =
		appCount !== undefined && appCount > 0
			? formatMessage(messages.moreWithCount, { appCount })
			: formatMessage(messages.more);

	return (
		<Flex role="presentation" alignItems="center">
			<JiraAppSelectorIconWithGithub />

			<Box xcss={styles.moreButtonStyles}>
				<Text size="small" align="center" color="color.text.subtle">
					{label}
				</Text>
			</Box>
		</Flex>
	);
};
